<template>
  <div class="store_section">
    <ul class="help_wrap help_wrap_pc">
      <li class="help_item">
        <router-link :to="{ name: 'CompanyAbout' }">
          <img src="@/assets/images/1.png" alt="회사소개" />
          <span class="base_NR20" style="line-height: 35px; display: block;"
            >캠퍼스북 회사소개<br
          /></span>
          <div class="new_more">View more</div>
        </router-link>
        <!-- <a href="https://www.hakjisa.co.kr/subpage.html?page=comp_comp01">
          <img src="@/assets/images/hakji_company_ico.png" alt="" />
          <span class="base_NR20">캠퍼스북 회사소개</span>
        </a> -->
      </li>
      <li class="help_item">
        <router-link :to="{ name: 'Partnership' }">
          <img src="@/assets/images/2.png" alt="출판사 제휴" />
          <span class="base_NR20" style="line-height: 35px; display: block;"
            >출판사 제휴 문의<br
          /></span>
          <div class="new_more">View more</div>
        </router-link>
        <!-- <a href="javascript:void(0)" @click="togglePartnership">
          <img src="@/assets/images/2.png" alt="" />
          <span class="base_NR20">출판사 제휴 문의<br /></span>
          <div class="new_more">View more</div>
        </a> -->
      </li>
      <li class="help_item">
        <router-link :to="{ name: 'guide' }">
          <img src="@/assets/images/3.png" alt="서비스소개 및 이용가이드" />
          <span class="base_NR20 ml-20">서비스소개 및 <br />이용가이드</span>
          <div class="new_more">View more</div>
        </router-link>
        <!-- <a href="javascript:void(0)" @click="dumpAlert">
          <img src="@/assets/images/hakji_service_ico.svg" alt="" />
          <span class="base_NR20">서비스소개 및 이용가이드</span>
        </a> -->
      </li>
      <li class="help_item">
        <!-- <a href="#ChannelIO" onclick="ChannelIO('show')"> -->
        <router-link
          :to="{
            name: 'faq'
          }"
        >
          <img src="@/assets/images/4.png" alt="고객센터" />
          <span class="base_NR20" style="line-height: 35px; display: block;"
            >고객센터</span
          >
          <div class="new_more">View more</div>
        </router-link>

        <!-- </a> -->
      </li>
    </ul>
    <ul class="help_wrap_mb help_wrap">
      <li class="help_item">
        <router-link :to="{ name: 'CompanyAbout' }">
          <img src="@/assets/images/1.png" alt="" />
          <span class="base_NR20">회사소개<br /></span>
        </router-link>
        <!-- <a href="https://www.hakjisa.co.kr/subpage.html?page=comp_comp01">
          <img src="@/assets/images/hakji_company_ico.png" alt="" />
          <span class="base_NR20">캠퍼스북 회사소개</span>
        </a> -->
      </li>
      <li class="help_item">
        <router-link :to="{ name: 'Partnership' }">
          <img src="@/assets/images/2.png" alt="" />
          <span class="base_NR20">제휴문의<br /></span>
        </router-link>
        <!-- <a href="javascript:void(0)" @click="togglePartnership">
          <img src="@/assets/images/2.png" alt="" />
          <span class="base_NR20">출판사 제휴 문의<br /></span>
          <div class="new_more">View more</div>
        </a> -->
      </li>
      <li class="help_item">
        <router-link :to="{ name: 'guide' }">
          <img src="@/assets/images/3.png" alt="" />
          <span class="base_NR20">이용가이드</span>
        </router-link>
        <!-- <a href="javascript:void(0)" @click="dumpAlert">
          <img src="@/assets/images/hakji_service_ico.svg" alt="" />
          <span class="base_NR20">서비스소개 및 이용가이드</span>
        </a> -->
      </li>
      <li class="help_item">
        <!-- <a href="#ChannelIO" onclick="ChannelIO('show')"> -->
        <router-link
          :to="{
            name: 'faq'
          }"
        >
          <img src="@/assets/images/4.png" alt="" />
          <span class="base_NR20">고객센터</span>
        </router-link>

        <!-- </a> -->
      </li>
    </ul>
    <transition v-on-clickaway="togglePartnership" name="modal-fade">
      <Modal v-if="showCompanyInfoModal" @close="togglePartnership">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <a class="btn_ly_close svg_close" @click="togglePartnership"
                ><span>{{ $t('library.deletemodal.close') }}</span></a
              >
            </div>
            <div class="ly_inner part_modal">
              <h1 class="txt_head">사업 제휴</h1>
              <div class="txt_wrap">
                <h2 class="base_NM20">(주)캠퍼스북</h2>
                <p class="base_NR14">담당부서 : 캠퍼스북 운영부</p>
                <p class="base_NR14">이 메 일 : admin@campusbook.co.kr</p>
                <p class="base_NR14">전화번호 : 070-4432-8810</p>
              </div>
              <!-- <p>
                  {{ errorMessage ? errorMessage : getAuthErrorMessage }}
                </p> -->
              <div class="btn_wrap">
                <button class="box_btn" @click="togglePartnership">
                  <span class="an_t">{{
                    $t('library.deletemodal.close')
                  }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'HelpDesk',
  data() {
    return {
      showCompanyInfoModal: false
    }
  },
  methods: {
    dumpAlert() {
      alert('서비스 준비중입니다.')
    },
    togglePartnership() {
      this.showCompanyInfoModal = !this.showCompanyInfoModal
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../src/assets/scss/_variables.scss';
.base_NR20 {
  font-size: 16px;
  white-space: nowrap;
}
.ly_pop_content {
  background-color: $white;
}
.part_modal {
  .txt_head {
    color: $h_BLUE_01;
    font-family: Gmarket-Sans;
    font-size: 32px;
    font-style: normal;
    font-weight: 500;

    text-align: center;
  }
  .txt_wrap {
    border-top: 1px solid $h_BLUE_01;
    background-color: #f0f5fa;
    padding: 33px 41px;
    h2 {
      margin-bottom: 24px;
      color: $h_BLUE_01;
    }
    p {
      color: grey;
    }
  }
}
.store_section {
  margin: auto;
  margin-bottom: 0;
  padding: 35px 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #f1f1f1;
  .help_wrap.help_wrap_mb {
    display: none;
  }
  .help_wrap {
    width: 100%;
    max-width: 850px;
    display: flex;
    justify-content: space-between;
    .help_item {
      max-width: 162px;
      text-align: center;
      flex-shrink: 0;
      color: #757575;
      a {
        display: inline-block;
      }
      img {
        width: 110px;
        height: 110px;
        margin-bottom: 10px;
      }
      .new_more {
        font-family: 'din-medium';
        color: #757575;
        border: 1px solid #c1c1c1;
        padding: 0.5rem 1rem;
        border-radius: 3px;
        margin: auto;
        margin-top: 1rem;
        width: 120px;
        font-size: 12px;
      }
    }
  }
}
@media (min-width: 1024px) {
  .desk-mr {
    margin-right: 20px !important;
  }
}
@media (max-width: 768px) {
  .help_wrap.help_wrap_pc {
    display: none;
  }
  .store_section .help_wrap.help_wrap_mb {
    display: flex;
    padding: 0px 50px;
    // grid-template-columns: repeat(auto-fill, minmax(140px, auto));
    place-items: center;
    .help_item {
      max-width: 130px;
      padding-right: 24px;
      text-align: center;
      a {
        width: 100%;
        .base_NR20 {
          font-size: 1.2em;
        }
        img {
          width: 100%;
          height: 100%;
          max-width: 110px;
        }
      }
    }
  }
}
@media (max-width: 570px) {
  .store_section .help_wrap.help_wrap_mb {
    padding: 0px 10px;
  }
  .store_section .help_wrap.help_wrap_mb .help_item {
    width: 25%;
    padding-right: 0px;
    padding: 0 10px;
    a {
      .base_NR20 {
        font-size: 1.1em;
      }
    }
  }
}
</style>
